import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { adminApi } from '../../api'
import { firstManagePath, type AdminMenuRow } from '../../lib/adminMenus'

export default function AdminIndexRedirect() {
  const [target, setTarget] = useState<string | null>(null)

  useEffect(() => {
    adminApi
      .get<{ menus: AdminMenuRow[] }>('/admin/auth/me')
      .then((r) => setTarget(firstManagePath(r.data.menus) || '/'))
      .catch(() => setTarget('/'))
  }, [])

  if (!target) {
    return (
      <div style={{ padding: 80, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    )
  }

  return <Navigate to={target} replace />
}
